import { Modal, Table, Tag, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faUser, faBuilding, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ExportarDetallesArchivos from "./ExportarDetallesArchivos"; // Ajusta la ruta
import { getRegistroNombre } from "./file-utils";

const { Text, Title } = Typography;

export default function FileDetailsModal({ isOpen, onClose, files, project, month }) {
  const filesWithParticipante = files.filter((f) => f.tipoRegistro === "participante").length;
  const filesWithOrganizacion = files.filter((f) => f.tipoRegistro === "organizacion").length;
  const filesSinRegistro = files.length - filesWithParticipante - filesWithOrganizacion;
  const getCleanFileName = (name) => name.replace(/^\d+-/, "");

  const columns = [
    {
      title: "Archivo",
      dataIndex: "name",
      key: "name",
      onCell: () => ({
        style: {
          paddingRight: 0,
          paddingLeft: 0,
        },
      }),
      render: (text, record) => {
        const cleanName = getCleanFileName(record.name);

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              maxWidth: "fit-content",
            }}
          >
            <FontAwesomeIcon
              icon={faFileLines}
              style={{ color: "#888", fontSize: 14 }}
            />
            <span
              title={cleanName}
              style={{
                display: "inline-block",
                whiteSpace: "nowrap",
                maxWidth: 350,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {cleanName}
            </span>
          </div>
        );
      },
    },
    {
      title: "Registrado a",
      key: "registrado",
      render: (_, record) => {
        const nombre = getRegistroNombre(record);
        if (record.tipoRegistro === "participante") {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FontAwesomeIcon icon={faUser} style={{ color: "#009728", fontSize: 14 }} />
              <Text>{nombre}</Text>
            </div>
          );
        }
        if (record.tipoRegistro === "organizacion") {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FontAwesomeIcon icon={faBuilding} style={{ color: "#1976D2", fontSize: 14 }} />
              <Text>{nombre}</Text>
            </div>
          );
        }
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#FAAD14", fontSize: 14 }} />
            <Text type="secondary">Sin registro</Text>
          </div>
        );
      },
    },
    {
      title: "Cédula / NIT / Sigla",
      key: "identificador",
      align: "center",
      render: (_, record) => {
        const identificador =
          record.tipoRegistro === "organizacion" && record.organizacion
            ? record.organizacion.Nit || record.organizacion.sigla
            : record.cedula;

        return identificador ? (
          <Text code>{identificador}</Text>
        ) : (
          <Text type="secondary">N/A</Text>
        );
      },
    },
    {
      title: "Estado",
      key: "status",
      align: "center",
      render: (_, record) => {
        if (record.tipoRegistro === "participante") {
          return (
            <Tag color="#009728" style={{ color: "white" }}>
              Participante
            </Tag>
          );
        }
        if (record.tipoRegistro === "organizacion") {
          return (
            <Tag color="#1976D2" style={{ color: "white" }}>
              Organización
            </Tag>
          );
        }
        return (
          <Tag color="#FAAD14" style={{ color: "white" }}>
            Sin registro
          </Tag>
        );
      },
    },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1000}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
        <div>
          <Title level={4} style={{ marginBottom: 4 }}>
            Archivos — {project} — {month}
          </Title>
          <Text type="secondary">
            Total: {files.length} archivos | Participantes: {filesWithParticipante} | Organizaciones: {filesWithOrganizacion} | Sin registro: {filesSinRegistro}
          </Text>
        </div>
        <ExportarDetallesArchivos
          files={files}
          project={project}
          month={month}
          filesWithParticipante={filesWithParticipante}
          filesWithOrganizacion={filesWithOrganizacion}
          filesSinRegistro={filesSinRegistro}
        />
      </div>

      <div style={{ marginTop: 20 }}>
        <Table
          columns={columns}
          dataSource={files}
          rowKey={(record, index) => record.path + "-" + index}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>
    </Modal>
  );
}
